import script from "./ProductRelated.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRelated.vue?vue&type=script&setup=true&lang=js"

import "./ProductRelated.vue?vue&type=style&index=0&id=5ec6ba79&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\cymcorp-site\\dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec6ba79"]])

export default __exports__